$(document).ready(() => {
  // Konstanten für DOM-Selektoren und häufig verwendete Strings
  const SELECTORS = {
    filterItem: '.filter-item',
    glossarCard: '.glossar .card',
    allFilter: '[data-filter="alle"]'
  };

  const CLASSES = {
    active: 'active-filter',
    inactive: 'inactive-filter',
    filteredIn: 'filtered-in',
    filteredOut: 'filtered-out'
  };

  const filterItems = $(SELECTORS.filterItem);
  const glossarCards = $(SELECTORS.glossarCard);
  const allFilterButton = $(SELECTORS.allFilter);

  const toggleFilterState = (clickedFilter) => {
    const filterType = clickedFilter.data('filter');
    const isAlreadyActive = clickedFilter.hasClass(CLASSES.active);
    
    if (isAlreadyActive && filterType !== 'alle') {
      // Deaktiviere aktuellen Filter und aktiviere "Alle"
      allFilterButton.addClass(CLASSES.active).removeClass(CLASSES.inactive);
      clickedFilter
        .removeClass(CLASSES.active)
        .addClass(CLASSES.inactive);
      
      applyFilter(filterType, true);
    } else {
      // Aktiviere neuen Filter
      allFilterButton
        .removeClass(CLASSES.active)
        .addClass(CLASSES.inactive);
      
      filterItems
        .removeClass(CLASSES.active)
        .addClass(CLASSES.inactive);
      
      clickedFilter
        .removeClass(CLASSES.inactive)
        .addClass(CLASSES.active);
      
      applyFilter(filterType, false);
    }
  };

  const applyFilter = (filterType, isDeactivating) => {
    if (isDeactivating || filterType === 'alle') {
      // Zeige alle Karten
      glossarCards
        .removeClass(CLASSES.filteredOut)
        .removeClass(CLASSES.filteredIn);
      return;
    }

    // Filtere Karten
    glossarCards.each((_, card) => {
      const $card = $(card);
      if ($card.hasClass(filterType)) {
        $card
          .removeClass(CLASSES.filteredOut)
          .addClass(CLASSES.filteredIn);
      } else {
        $card
          .removeClass(CLASSES.filteredIn)
          .addClass(CLASSES.filteredOut);
      }
    });
  };

  // Event Listener
  filterItems.on('click', function() {
    toggleFilterState($(this));
  });
});